import React                   from 'react';

import colors                  from '../../utils/colors';
import { makeStyles }          from '@material-ui/core/styles';

const heb: { [val: string]: string } = {
    'check': 'בדיקה',
    'next':  'המשך',
    'error': 'נסו שוב',
    'fix':   'תקנו'
}


const useStyles = makeStyles(() => ({
    
    button: {
       // position:        'absolute',
        marginLeft:      '50%',
        marginTop:       -20,
        height:          40,
        fontSize:        20,
        minHeight:       40,
        backgroundColor: colors.blue,
        color:           '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        borderRadius:    '0.5em',
        cursor:          'pointer'
    }
}))

type ButtonProps = {
    testsArr:         number[];
    failureCounter:   number;
    success:          boolean;
    showError:        boolean;
    wideScreen:       boolean;
    stage1complete:   boolean;
    showActionButton: boolean;
    error:            string;
    wrongAnswer:      string;
    tooSlow:          string;
    wrongMehubarim:   string;
    submit:           () => void;
}

const Button: React.FC<ButtonProps> = ({ 
    testsArr, 
    failureCounter,
    success, 
    showError, 
    stage1complete,
    showActionButton,
    error,
    wideScreen,
    wrongAnswer,
    tooSlow,
    wrongMehubarim,
    submit 
  }) => {

  const classes = useStyles();

  const showNextButton = React.useMemo(() => {
    return (success || failureCounter >= 2) || (showError && error === tooSlow) 
  },[success, failureCounter, showError, error, tooSlow])

  return (
        <div 
           className = { classes.button }
           onClick   = { () => { if (showActionButton && testsArr.length) { submit() }}}
           style     = {{
           // top:       (size[1]/2) - target_size/2 - 140,
            transform: `translate(-50%, ${ showActionButton && testsArr.length ? 0 : -150 }vh)`, 
            //opacity:   showActionButton && testsArr.length ? 1 : 0,
            //cursor:    showActionButton && testsArr.length ? 'pointer' : 'default',
            width:     wideScreen ? 140 : 90,
          }}
        >
            { showNextButton ? heb['next'] : (showError && error === wrongMehubarim) ? heb['error'] : (showError && error === wrongAnswer) ? !stage1complete ? heb['fix'] : heb['error'] : heb['check'] }
        </div>
       
  );
}



export default Button;








